import React from 'react';
import { formatCurrencyNumber } from '../../../Common/format';

const getCardBrandIcon = (card) => {
    const cardBrandExtended = card.toLowerCase();
    if (cardBrandExtended.includes('visa')) {
        return 'visa';
    }
    if (cardBrandExtended.includes('master')) {
        return 'master';
    }
};

const PaymentsTableRow = ({ amount, card, installments, installmentsAmount }) => {
    return (
        <tr>
            <td>
                <i className={`fab fa-cc-${getCardBrandIcon(card.brand)} mr-2`} />
                {card.trunc}
                <span className="d-block small ml-4">{card.holder}</span>
            </td>
            <td>{installments}x R$ {formatCurrencyNumber(installmentsAmount)}</td>
            <td className="text-right">R$ {formatCurrencyNumber(amount)}</td>
        </tr>
    );
}

export default PaymentsTableRow;


// WEBPACK FOOTER //
// ./src/components/Pages/Receipt/PaymentsTableRow.js